import GATSBY_COMPILED_MDX from "/Users/adhamelarabawy/code/adham-elarabawy.github.io/src/projects/open_quadruped.mdx";
import React from "react";
import {navigate} from "gatsby";
import {MDXProvider} from "@mdx-js/react";
import {Link} from "gatsby";
import {PageLayout} from "../components/PageLayout";
import {Button, Container} from "@mantine/core";
import {IconArrowLeft} from "@tabler/icons-react";
import {useMantineTheme} from "@mantine/core";
const shortcodes = {
  Link
};
function PageTemplate(_ref) {
  let {data, children} = _ref;
  const theme = useMantineTheme();
  const gridColor = theme.colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)';
  const bgColor = theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0];
  const handleBackClick = () => {
    navigate("/");
  };
  return React.createElement(PageLayout, null, React.createElement("div", {
    style: {
      minHeight: '100vh',
      backgroundImage: `
          linear-gradient(${gridColor} 0.5px, transparent 0.5px),
          linear-gradient(90deg, ${gridColor} 0.5px, transparent 0.5px)
        `,
      backgroundSize: '20px 20px',
      backgroundPosition: '10px 10px',
      padding: '20px'
    }
  }, React.createElement(Container, null, React.createElement(Button, {
    leftSection: React.createElement(IconArrowLeft, {
      size: 16
    }),
    onClick: handleBackClick,
    variant: "subtle",
    color: theme.colorScheme === 'dark' ? 'gray.4' : 'dark',
    styles: theme => ({
      root: {
        padding: '8px 16px',
        transition: 'all 0.2s ease',
        '&:hover': {
          transform: 'translateX(-4px)',
          backgroundColor: 'transparent'
        }
      }
    })
  }, "Back to Projects"), React.createElement("div", {
    style: {
      backgroundColor: `${bgColor}ee`,
      padding: '30px',
      borderRadius: theme.radius.md,
      marginTop: '20px',
      backdropFilter: 'blur(5px)'
    }
  }, React.createElement("h1", null, data.mdx.frontmatter.title), React.createElement("p", null, data.mdx.frontmatter.description), React.createElement(MDXProvider, {
    components: shortcodes
  }, children)))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const query = "2894591893";
